const awsmobile = {
  aws_project_region: 'eu-west-2',
  aws_cognito_region: 'eu-west-2',
  aws_user_pools_id: 'eu-west-2_AK4h6MEiM',
  aws_user_pools_web_client_id: '778t4bsqj0taofju80rv36bn1b',
  aws_cognito_identity_pool_id: 'eu-west-2:1ca459e1-a163-4adf-b225-f90a21ba7ba6',
  oauth: {},
  aws_cloud_logic_custom: [
    {
      name: 'braingridapi',
      endpoint: 'https://jeabwk7au0.execute-api.eu-west-2.amazonaws.com/braingrid',
      region: 'eu-west-2',
    },
  ],
};

export default awsmobile;
